import styled from 'styled-components';

export const MarkdownWrapper = styled.div`
    word-break: break-word;

    > div img {
        max-width: 100%;
    }
`;
